var map = {
	"./fortuneIcon.svg": 392,
	"./fortuneIconL.svg": 393,
	"./helpdeskIcon.svg": 394,
	"./helpdeskIconL.svg": 395,
	"./homeIcon.svg": 396,
	"./homeIconLarge.svg": 397,
	"./jackpotIcon.svg": 398,
	"./logo.svg": 399,
	"./logoSmall.svg": 400,
	"./loyaltyIcon.svg": 401,
	"./mobileAppIcon.svg": 402,
	"./profileIcon.svg": 403,
	"./questIcon.svg": 404,
	"./rewardLineupIcon.svg": 405,
	"./searchIcon.svg": 406,
	"./searchIconLarge.svg": 407,
	"./signOutIcon.svg": 408,
	"./star.svg": 409,
	"./tournamentIcon.svg": 410,
	"./tournamentLargeIcon.svg": 411,
	"./vipIcon.svg": 412,
	"./wheelIcon.svg": 413,
	"./wheelIconL.svg": 414,
	"./wheelIconMobile.svg": 415
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;